import { render } from "./Home.vue?vue&type=template&id=21a511e2"
const script = {}

import exportComponent from "F:\\leeao\\leeplus_docs_code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__